//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import BaseDialogVue from '../../components/base/BaseDialog.vue'
import BaseImageInputVue from '../../components/base/BaseImageInput.vue'
import BaseOutlineButtonVue from '../../components/base/BaseOutlineButton.vue'
import wxlogin from 'vue-wxlogin'
import env from '../../plugins/environment'
import baseUrl from '../../api/baseURL'
import rules from '../../plugins/rules'

export default {
  components: { BaseOutlineButtonVue, BaseDialogVue, BaseImageInputVue, wxlogin },

  data() {
    return {
      nickname: '',
      image: { url: '' },
      uploadImageDialog: false,
      bindWechatDialog: false,
      bindMobileDialog: false,
      wx: {
        appid: 'wx28e708201e3983b8',
        scope: 'snsapi_login',
        redirect_uri: env.isProd()
          ? encodeURIComponent('https://www.chongya.fun/account')
          : encodeURIComponent('https://www.chongya.fun/beta/account'),
        state: 'bind',
        theme: 'white',
        href:window.parent.location.origin + '/wechatCodeStyle.css',
      },
      activeDate: 1,
      rules,
      phoneNumber: '',
      verifyPic: null,
      picVerifyCode: '',
      smsVerifyCode: '',
      sendSmsButtonMessage: '发送验证码',
      showPicVerifyInput: false,
      isSubmitButtonDisabled: true,
      isSendSmsVerifyCodeDisabled: false,
      sendSmsCountDown: 60,
      sendSmsInterval: null,
    }
  },

  computed: {
    ...mapState('user', ['userInfo']),
  },

  methods: {
    requestModifyNickName() {
      if (this.$refs.nickname.validate()) {
        let newUserInfo = this.userInfo
        newUserInfo.nickName = this.nickname
        this.$store.dispatch('user/updateUserInfo', {
          userInfo: newUserInfo,
          callback: () => {
            this.$q.notify('更新资料成功')
            this.$router.push('/collection')
          },
          errorCallback: (error) => {
            this.$q.notify('更新用户昵称的网络请求出现错误')
            console.log('更新用户昵称的网络请求出现错误：', error)
          },
        })
      }
    },

    onUpdateAvatarUrl(newUrl) {
      this.avatarUrl = newUrl
    },

    requestModifyAvatarUrl() {
      let newUserInfo = this.userInfo
      newUserInfo.avatarUrl = this.image.url
      this.$store.dispatch('user/updateUserInfo', {
        userInfo: newUserInfo,
        callback: () => {
          this.$q.notify('更新头像成功')
          this.uploadImageDialog = false
        },
        errorCallback: (error) => {
          this.$q.notify('更新用户头像的网络请求出现错误')
          console.log('更新用户头像的网络请求出现错误：', error)
        },
      })
    },

    sendSms() {
      if (this.$refs.picVerifyCode.validate()) {
        this.$store.dispatch('user/sendSms', {
          mobile: this.phoneNumber,
          picVerifyCodeStr: this.picVerifyCode,
          callback: (res) => {
            // 先执行一次计时器的第一秒
            this.sendSmsCountDown--
            this.sendSmsButtonMessage = `${this.sendSmsCountDown}秒后可重发`
            if (!this.isSendSmsVerifyCodeDisabled) {
              this.isSendSmsVerifyCodeDisabled = true
            }
            // 开始 60 秒倒计时
            this.sendSmsInterval = window.setInterval(() => {
              if (this.sendSmsCountDown != 0) {
                this.sendSmsCountDown--
                this.sendSmsButtonMessage = `${this.sendSmsCountDown}秒后可重发`
                if (!this.isSendSmsVerifyCodeDisabled) {
                  this.isSendSmsVerifyCodeDisabled = true
                }
              } else {
                window.clearInterval(this.sendSmsInterval)
                this.sendSmsCountDown = 60
                this.sendSmsButtonMessage = `发送验证码`
                this.isSendSmsVerifyCodeDisabled = false
              }
            }, 1000)

            console.log(res)
          },
          errorCallback: (res) => {
            console.log(res)
            if (res.data.code == 400) {
              this.$q.notify('图形验证码错误')
            } else {
              this.$q.notify(`发送短信验证码失败，请联系管理员，错误代码：${this.data.code}`)
            }
            this.refreshVerificationPic()
          },
        })
      }
    },

    refreshVerificationPic() {
      // 在验证码页面后加一个随机的参数，防止刷新验证码刷新不动。
      const random = Math.round(Math.random() * 1e17)
      this.verifyPic = `${baseUrl}/common/getPicVerifyCode?mobile=${this.phoneNumber}&random=${random}`
    },

    getPicVerifyCode() {
      this.phoneNumber = this.phoneNumber.trim()

      this.$nextTick(() => {
        if (this.$refs.phoneNumber.validate()) {
          console.log('手机号合法，请求验证码')
          this.refreshVerificationPic()
          this.showPicVerifyInput = !this.showPicVerifyInput
        }
        console.log(this.$refs.phoneNumber.value)
      })
    },

    // 点击提交按钮响应，发起绑定手机请求
    bindMobile() {
      if (this.$refs.picVerifyCode.validate()) {
        this.$store.dispatch('user/bindMobile', {
          mobile: this.phoneNumber,
          code: this.smsVerifyCode,
          callback: () => {
            this.bindMobileDialog = false
            this.$q.notify('绑定成功！')
          },
          errorCallback: (res) => {
            this.refreshVerificationPic()
            if (res.data.code == 400) {
              this.$q.notify('绑定微信失败：验证码错误，或手机号已被注册')
            } else {
              this.$q.notify(`绑定手机出现问题，请联系管理员，错误代码：${this.data.code}`)
            }
          },
        })
      }
    },

    resetValidation(refsName) {
      this.$refs[refsName].resetValidation()
    },
  },

  watch: {
    // 短信验证码的 input 有值时，提交按钮才可以点击
    smsVerifyCode() {
      if (this.$refs.smsVerifyCode.validate()) {
        this.isSubmitButtonDisabled = false
      } else {
        this.isSubmitButtonDisabled = true
      }
    },
  },

  created() {
    this.nickname = this.userInfo.nickName
  },

  mounted() {
    if (this.$route.query.code && this.$route.query.state) {
      this.$store.dispatch('user/bindWechat', {
        code: this.$route.query.code,
        state: this.$cookies.get('userInfo').mobile, // 传给后端 state 为手机号，意味着是绑定微信而非用用微信登录
        callback: () => {
          this.$q.notify('绑定成功！')
          this.$router.push('/account')
          this.bindWechatDialog = false
        },
        errorCallback: (res) => {
          console.log(res)
          this.$router.push('/account')
          this.$q.notify(`绑定失败，${res}`)
        },
      })
    }
  },
}
